
    import React from 'react';
    import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../components/Svg/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "exclamation-gold--sprite",
  "use": "exclamation-gold--sprite-usage",
  "viewBox": "0 0 26 26",
  "content": "<symbol viewBox=\"0 0 26 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"exclamation-gold--sprite\"><path d=\"M13 7v7m12-1c0 6.627-5.373 12-12 12S1 19.627 1 13 6.373 1 13 1s12 5.373 12 12zm-11.25 5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0z\" stroke=\"url(#exclamation-gold--sprite_exclamation-gold_svg__a)\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><defs><linearGradient id=\"exclamation-gold--sprite_exclamation-gold_svg__a\" x1=\"1\" y1=\"13\" x2=\"25\" y2=\"13\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#F5CF3E\" /><stop offset=\"1\" stop-color=\"#E8AF58\" /></linearGradient></defs></symbol>"
});
    sprite.add(symbol);

    export default class ExclamationGoldSpriteSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="exclamation-gold--sprite" viewBox="0 0 26 26" {...this.props} />;
      }
    }
  